export const MILES_TO_METERS = 1609.344;
export const MIN_RADIUS_MILES = 0.05;
export const MAX_RADIUS_MILES = 5;
export const DEFAULT_RADIUS_MILES = 1;
export const RADIUS_STEP_MILES = 0.05;

/** API expects whole meters (no fractional meters). */
export function milesToMeters(miles) {
  return Math.round(miles * MILES_TO_METERS);
}

export function clampMiles(miles) {
  const stepped = Math.round(miles / RADIUS_STEP_MILES) * RADIUS_STEP_MILES;
  return Math.min(
    MAX_RADIUS_MILES,
    Math.max(MIN_RADIUS_MILES, stepped),
  );
}
